// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 账号密码登录 POST /api/auth/login */
export async function login(
  data: API.LoginParams,
  options?: { [key: string]: any },
) {
  return request<API.Result<API.LoginResponse>>('/api/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 选择管理员身份登录 POST /api/auth/select-admin */
export async function selectAdmin(
  data: API.SelectAdminParams,
  options?: { [key: string]: any },
) {
  return request<API.Result<API.LoginResponseSingle>>('/api/auth/select-admin', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 获取当前用户信息 GET /api/admin/account/current */
export async function getCurrentUser(options?: { [key: string]: any }) {
  return request<API.Result<API.CurrentUserResponse>>('/api/admin/account/current', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取用户权限菜单 GET /api/admin/account/menus */
export async function getUserMenus(
  params: {
    menuType: API.MenuType;
  },
  options?: { [key: string]: any },
) {
  return request<API.Result<API.MenuListResponse>>('/api/admin/account/menus', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

/** 获取管理员路由菜单 GET /api/admin/routes */
export async function getAdminRoutes(options?: { [key: string]: any }) {
  return request<API.Result<API.MenuListResponse>>('/api/admin/routes', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取管理员身份列表 GET /api/admin/account/admin-list */
export async function getAdminList(options?: { [key: string]: any }) {
  return request<API.Result<API.AdminListResponse>>('/api/admin/account/admin-list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 切换管理员身份 POST /api/admin/account/switch-admin */
export async function switchAdmin(
  data: API.SwitchAdminParams,
  options?: { [key: string]: any },
) {
  return request<API.Result<API.SwitchAdminResponse>>('/api/admin/account/switch-admin', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/** 发送验证码 POST /api/login/captcha */
export async function getFakeCaptcha(
  params: {
    // query
    /** 手机号 */
    phone?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.FakeCaptcha>('/api/login/captcha', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
